module.exports = "/dashboard/manage/users/modal-invite-success-4acab1.html";